import type { BariPostNurseSpecialistFollowUpDataV1 } from '@common/validation/customControls/bariPost/bariPostNurseSpecialistFollowUp/v1/bariPostNurseSpecialistFollowUpDataV1';
import { initialData } from '../bariPostNurseSpecialistFollowUpDataBase';

export const initialDataV1: BariPostNurseSpecialistFollowUpDataV1 = {
    ...initialData,
    diabetes_mellitus_medicamenteuze_veranderingen: null,
    dyslipidemie_medicamenteuze_veranderingen: null,
    gastroesophageal_reflux_disease_medicamenteuze_veranderingen: null,
    gewrichtsklachten_therapeutische_veranderingen: null,
    hypertensie_medicamenteuze_veranderingen: null,
    osas_therapeutische_veranderingen: null,
    roken: null,
    roken_aantal_pack_years: null,
    roken_gestopt_sinds: null,
    roken_toelichting: null,
};
